export default "__VITE_ASSET__B4hHTi8n__"